import { combineReducers } from "redux";

import { Actions } from "./actions";
import editorReducer, { RouteEditorState } from "./editor";
import routeLeadFinderReducer, { RouteLeadFinderState } from "./leadFinder";
import { mapReducer, RouteMapState } from "./map";
import viewReducer, { RouteViewState } from "./view";

export interface RouteDetailsState {
  editor: RouteEditorState;
  leadFinder: RouteLeadFinderState;
  map: RouteMapState;
  view: RouteViewState;
}

const routeDetails = combineReducers<RouteDetailsState, Actions>({
  editor: editorReducer,
  leadFinder: routeLeadFinderReducer,
  map: mapReducer,
  view: viewReducer,
});

export type RouteDetailsActions = Actions;
export default routeDetails;
